var _excluded = ["items", "transformItems"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useSortBy } from 'react-instantsearch-core';
import { SortBy as SortByUiComponent } from "../ui/SortBy.js";
export function SortBy(_ref) {
  var items = _ref.items,
    transformItems = _ref.transformItems,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSortBy = useSortBy({
      items: items,
      transformItems: transformItems
    }, {
      $$widgetType: 'ais.sortBy'
    }),
    currentRefinement = _useSortBy.currentRefinement,
    options = _useSortBy.options,
    refine = _useSortBy.refine;
  var uiProps = {
    items: options,
    value: currentRefinement,
    onChange: refine
  };
  return /*#__PURE__*/React.createElement(SortByUiComponent, _extends({}, props, uiProps));
}